module.exports = __webpack_public_path__ + "static/media/MicrosoftJhengHeiRegular-01.2da00e95.ttf";